import React from 'react';
import { config } from 'config';
import { statisticsActions } from 'core/Statistics';
import { useTranslation } from 'react-i18next';
import {
    Card,
    Text
} from 'mol-ui';
import {
    Col,
    Row
} from 'reactstrap';
import {
    StatisticsItem,
    StatisticsLayout
} from 'views/components';
import {
    useDispatch,
    useSelector
} from 'hooks';

const {
    asyncConsults,
    billing,
    orderCreation,
    patientHistoryRegistration,
    prework,
    recipes,
    turns
} = config;

const StatisticsGeneral = () => {

    const dispatch = useDispatch();
    const { t } = useTranslation();
    const {
        general,
        loading
    } = useSelector('statistics');

    const onFiltersChange = filters => {
        dispatch(statisticsActions.getStatisticsGeneral(filters));
    };

    const {
        appointments = {},
        bills = {},
        consultations = {},
        diagnostics = {},
        orders = {},
        patients = {},
        preworks = {},
        professionals: professionalsStatistics = {},
        recipes: recipesStatistics = {}
    } = general;

    const {
        confirmed_qty: appointments_confirmed_qty,
        finalized_qty: appointments_finalized_qty,
        new_qty: appointments_new_qty,
        oncurse_qty: appointments_oncurse_qty,
        total_qty: appointments_total_qty,
        unconfirmed_qty: appointments_unconfirmed_qty
    } = appointments;

    const {
        new_qty: bills_new_qty,
        total_qty: bills_total_qty
    } = bills;

    const {
        new_qty: consultations_new_qty,
        unreaded_qty: consultations_unreaded_qty,
        total_qty: consultations_total_qty
    } = consultations;

    const {
        new_qty: diagnostics_new_qty,
        total_qty: diagnostics_total_qty
    } = diagnostics;

    const {
        new_qty: orders_new_qty,
        total_qty: orders_total_qty
    } = orders;

    const {
        new_qty: patients_new_qty,
        total_qty: patients_total_qty
    } = patients;

    const {
        new_qty: preworks_new_qty,
        total_qty: preworks_total_qty
    } = preworks;

    const {
        new_qty: professionals_new_qty,
        total_qty: professionals_total_qty
    } = professionalsStatistics;

    const {
        new_qty: recipes_new_qty,
        total_qty: recipes_total_qty
    } = recipesStatistics;

    return (
        <StatisticsLayout
            loading={ loading }
            title={ t('General') }
            onFiltersChange={ onFiltersChange }
        >
            <>
                {
                    turns &&
                    <Row>
                        <Col xs={ 12 }>
                            <Text fontSize="14px" margin="10px 0px 0px 0px">
                                { t('Turnos') }
                            </Text>
                        </Col>
                        <Col sm={ 4 } xs={ 12 }>
                            <Card padding="10px">
                                <StatisticsItem text={ t('Confirmados') } value={ appointments_confirmed_qty } />
                                <StatisticsItem text={ t('No confirmados') } value={ appointments_unconfirmed_qty } />
                            </Card>
                        </Col>
                        <Col sm={ 4 } xs={ 12 }>
                            <Card>
                                <StatisticsItem text={ t('En curso') } value={ appointments_oncurse_qty } />
                                <StatisticsItem text={ t('Atendidos') } value={ appointments_finalized_qty } />
                            </Card>
                        </Col>
                        <Col sm={ 4 } xs={ 12 }>
                            <Card>
                                <StatisticsItem text={ t('Nuevos') } value={ appointments_new_qty } />
                                <StatisticsItem text={ t('Totales') } value={ appointments_total_qty } />
                            </Card>
                        </Col>
                    </Row>
                }
                <Row>
                    <Col sm={ 4 } xs={ 12 }>
                        <Text fontSize="14px" margin="10px 0px 0px 0px">
                            { t('Pacientes') }
                        </Text>
                        <Card padding="10px">
                            <StatisticsItem text={ t('Nuevos') } value={ patients_new_qty } />
                            <StatisticsItem text={ t('Total') } value={ patients_total_qty } />
                        </Card>
                    </Col>
                    <Col sm={ 4 } xs={ 12 }>
                        <Text fontSize="14px" margin="10px 0px 0px 0px">
                            { t('Profesionales') }
                        </Text>
                        <Card padding="10px">
                            <StatisticsItem text={ t('Nuevos') } value={ professionals_new_qty } />
                            <StatisticsItem text={ t('Total') } value={ professionals_total_qty } />
                        </Card>
                    </Col>
                    {
                        patientHistoryRegistration &&
                        <Col sm={ 4 } xs={ 12 }>
                            <Text fontSize="14px" margin="10px 0px 0px 0px">
                                { t('Evoluciones') }
                            </Text>
                            <Card padding="10px">
                                <StatisticsItem text={ t('Nuevas') } value={ diagnostics_new_qty } />
                                <StatisticsItem text={ t('Totales') } value={ diagnostics_total_qty } />
                            </Card>
                        </Col>
                    }
                    {
                        billing &&
                        <Col sm={ 4 } xs={ 12 }>
                            <Text fontSize="14px" margin="10px 0px 0px 0px">
                                { t('Facturas') }
                            </Text>
                            <Card padding="10px">
                                <StatisticsItem text={ t('Nuevas') } value={ bills_new_qty } />
                                <StatisticsItem text={ t('Totales') } value={ bills_total_qty } />
                            </Card>
                        </Col>
                    }
                    {
                        asyncConsults &&
                        <Col sm={ 4 } xs={ 12 }>
                            <Text fontSize="14px" margin="10px 0px 0px 0px">
                                { t('Consultas escritas') }
                            </Text>
                            <Card padding="10px">
                                <StatisticsItem text={ t('Nuevas') } value={ consultations_new_qty } />
                                <StatisticsItem text={ t('No leídas') } value={ consultations_unreaded_qty } />
                                <StatisticsItem text={ t('Total') } value={ consultations_total_qty } />
                            </Card>
                        </Col>
                    }
                    {
                        recipes &&
                        <Col sm={ 4 } xs={ 12 }>
                            <Text fontSize="14px" margin="10px 0px 0px 0px">
                                { t('Recetas') }
                            </Text>
                            <Card padding="10px">
                                <StatisticsItem text={ t('Nuevas') } value={ recipes_new_qty } />
                                <StatisticsItem text={ t('Total') } value={ recipes_total_qty } />
                            </Card>
                        </Col>
                    }
                    {
                        orderCreation &&
                        <Col sm={ 4 } xs={ 12 }>
                            <Text fontSize="14px" margin="10px 0px 0px 0px">
                                { t('Órdenes') }
                            </Text>
                            <Card padding="10px">
                                <StatisticsItem text={ t('Nuevas') } value={ orders_new_qty } />
                                <StatisticsItem text={ t('Total') } value={ orders_total_qty } />
                            </Card>
                        </Col>
                    }
                    {
                        prework &&
                        <Col sm={ 4 } xs={ 12 }>
                            <Text fontSize="14px" margin="10px 0px 0px 0px">
                                { t('Controles ocupacionales') }
                            </Text>
                            <Card padding="10px">
                                <StatisticsItem text={ t('Nuevas') } value={ preworks_new_qty } />
                                <StatisticsItem text={ t('Total') } value={ preworks_total_qty } />
                            </Card>
                        </Col>
                    }
                    
                </Row>
            </>
        </StatisticsLayout>
    );
};

StatisticsGeneral.propTypes = {

};

export default StatisticsGeneral;
